export default __webpack_public_path__ + "static/media/MF-white.90a4b4c4.png";